import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import api from '../lib/api';
export var SET_AUTHENTICATED_USER = 'SET_AUTHENTICATED_USER';
export var SET_REFRESHINPROGRESS_USER = 'SET_REFRESHINPROGRESS_USER';
export var SET_ACTIVE_USER = 'USER_SET_ACTIVE_USER';
export var SET_ACTIVE_STUDENT = 'USER_SET_ACTIVE_STUDENT';
export var SET_ACTIVE_SCHOOL = 'USER_SET_ACTIVE_SCHOOL';
export var GET_READER_PARAMS = 'USER_GET_READER_PARAMS';
export var GET_STUDENT_SCHOOL_DATA = 'GET_STUDENT_SCHOOL_DATA';
export var SET_HALDOR_APP_ORIENTATION = 'SET_HALDOR_APP_ORIENTATION';
import { setActiveStudent as storage_setActiveStudent, getActiveStudent as storage_getActiveStudent, setActiveSchool as storage_setActiveSchool, getActiveSchool as storage_getActiveSchool } from 'helpers/guardian';
export var setHaldorAppOrientation = function setHaldorAppOrientation(layout) {
  return {
    type: SET_HALDOR_APP_ORIENTATION,
    payload: layout
  };
};
export var setAuthenticated = function setAuthenticated(isAuthenticated) {
  return {
    type: SET_AUTHENTICATED_USER,
    payload: isAuthenticated
  };
};
export var setRefreshInProgress = function setRefreshInProgress(isRefreshInProgress) {
  return {
    type: SET_REFRESHINPROGRESS_USER,
    payload: isRefreshInProgress
  };
};
export var setActiveUser = function setActiveUser(user) {
  return {
    type: SET_ACTIVE_USER,
    payload: user
  };
};
export var setActiveStudent = function setActiveStudent(student) {
  return {
    type: SET_ACTIVE_STUDENT,
    payload: new Promise(function (resolve, reject) {
      var prevStudent = storage_getActiveStudent();
      storage_setActiveStudent(student.id); // setActiveStudent before api call in order to get correct studentId for the call
      api.get("students/".concat(student.id)).then(function (response) {
        if (response.status == 204) {
          storage_setActiveStudent(prevStudent); // reset active student
          reject();
        }
        resolve(response.data);
      });
    })
  };
};
export var setActiveSchool = function setActiveSchool(school, student) {
  return {
    type: SET_ACTIVE_SCHOOL,
    payload: new Promise(function (resolve) {
      storage_setActiveSchool(school, student);
      resolve(school);
    })
  };
};
export function getReaderParameters() {
  return {
    type: GET_READER_PARAMS,
    payload: new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
        var token, subdomain;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return new Promise(function (resolve) {
                api.get("cognitiveServices/token").then(function (response) {
                  resolve(response.data);
                });
              });
            case 2:
              token = _context.sent;
              _context.next = 5;
              return new Promise(function (resolve) {
                api.get("cognitiveServices/subdomain").then(function (response) {
                  resolve(response.data);
                });
              });
            case 5:
              subdomain = _context.sent;
              resolve({
                subdomain: subdomain,
                token: token
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }())
  };
}
export var getSchoolData = function getSchoolData(studentId, key) {
  return {
    type: GET_STUDENT_SCHOOL_DATA,
    payload: new Promise(function (resolve) {
      api.get("students/".concat(studentId, "/schoolsdata/").concat(key)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};